module.exports = __webpack_public_path__ + "assets/7.png";


//////////////////
// WEBPACK FOOTER
// ./images/7.png
// module id = 702
// module chunks = 0